import { formatFileName, isEmpty } from 'src/views/utils/helper'
import { getPresignedPostUrl, updateJobStatus } from './upload-file'
import { CHUNK_SIZE } from 'src/views/utils/constants'
import axios from 'axios'

const createChunks = (file) => {
  let startPointer = 0
  let endPointer = file.size
  let chunks = []
  while (startPointer < endPointer) {
    let newStartPointer = startPointer + CHUNK_SIZE
    chunks.push(file.slice(startPointer, newStartPointer))
    startPointer = newStartPointer
  }
  return chunks
}

export async function multipleSignedUrl(uplaodFiles, accountId, languages = []) {
  if (uplaodFiles && uplaodFiles.length) {
    let assetData = []
    let tempFileName = []
    let tempChunksAndUrls = {}
    let assetObj = {}

    for (let index = 0; index < uplaodFiles.length; index++) {
      const file = uplaodFiles[index]
      const fileChunks = await createChunks(file)
      const formatedName = formatFileName(file.name)

      tempFileName.push(formatedName)

      tempChunksAndUrls[`${formatedName}`] = {}

      tempChunksAndUrls[`${formatedName}`][`chunks`] = fileChunks

      if (isEmpty(languages)) {
        assetObj = {
          file_name: formatedName,
          file_metadata: {
            file_size: file.size,
            file_type: file.type,
          },
          file_type: file.fileType,
          num_parts: fileChunks.length,
        }
      } else {
        assetObj = {
          file_name: formatedName,
          file_metadata: {
            file_size: file.size,
            file_type: file.type,
            language: languages[index],
          },
          file_type: file.fileType,
          num_parts: fileChunks.length,
        }
      }

      assetData.push(assetObj)
    }

    const signedURLRes = await getPresignedPostUrl({
      customer_id: accountId,
      upload_type: 'FROM_DEVICE',
      assets: assetData,
    })

    if (signedURLRes?.success) {
      let completedAssetIDs = []
      for (let index = 0; index < tempFileName.length; index++) {
        const fileName = tempFileName[index]
        let ETagMap = {}
        let jobData = {}
        let awsSuccess = 0
        for (
          let chunkIdx = 0;
          chunkIdx < tempChunksAndUrls[`${fileName}`][`chunks`].length;
          chunkIdx++
        ) {
          const chunk = tempChunksAndUrls[`${fileName}`].chunks[chunkIdx]

          const AWSUploadResponse = await axios.put(
            signedURLRes.data[`${fileName}`].signed_url_dict[chunkIdx + 1],
            chunk,
          )

          if (AWSUploadResponse.status === 200) {
            awsSuccess++
            ETagMap[`${chunkIdx + 1}`] = AWSUploadResponse.headers?.etag
          }
        }

        if (awsSuccess === tempChunksAndUrls[`${fileName}`][`chunks`].length) {
          jobData[`${signedURLRes.data[`${fileName}`].asset_id}`] = {
            status: 'SUCCESS',
            etag_map: ETagMap,
          }

          const jobUpdateRes = await updateJobStatus(
            jobData,
            signedURLRes.data[`job_id`],
            accountId,
          )
          if (jobUpdateRes.success) {
            completedAssetIDs.push(signedURLRes.data[`${fileName}`].asset_id)
          } else {
          }
        } else {
          jobData[`${signedURLRes.data[`${fileName}`].asset_id}`] = { status: 'FAILED' }
          await updateJobStatus(jobData, signedURLRes.data[`job_id`], accountId)
        }
      }

      return {
        completedAssets: completedAssetIDs,
        success: true,
      }
    } else {
      return {
        success: false,
      }
    }
  } else {
    return {
      success: false,
    }
  }
}
